// extracted by mini-css-extract-plugin
export default {"container":"InlineSetting_container__WJqLG","title":"InlineSetting_title__6EuRk","right_container":"InlineSetting_right_container__3vkTW","divider":"InlineSetting_divider__WvO9S"};